export const MAIN_CONTAINER_WIDTH = 1225;
//# sourceMappingURL=constants.js.map